import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import styled from "styled-components";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useEffect } from "react";
import HoverIcon from "../HoverIcon";

const ListContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const theme = createTheme({
  palette: {
    primary: {
      main: "#1e173f",
    },
  },
});

const CheckboxContainer = styled.div`
  white-space: pre-line;
`;

export default function CheckboxList({
  points,
  indented,
  updateSectionCheck,
  sectionCode,
  checkboxClicked,
  disabled,
}) {
  const [checked, setChecked] = React.useState([0]);
  const checkpoints = points;

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value.point);
    const newChecked = [...checked];
    checkboxClicked(value.id);

    if (currentIndex === -1) {
      newChecked.push(value.point);
      // updateSectionCheck(sectionCode, 1);
    } else {
      newChecked.splice(currentIndex, 1);
      // updateSectionCheck(sectionCode, -1);
    }
    setChecked(newChecked);
  };

  return (
    <CheckboxContainer>
      {checkpoints.map((value, index) => {
        const point = value.point;
        const labelId = point;
        return (
          <ListContainer key={`checkpoint-${point}-${index}`}>
            <ListItem
              sx={{
                paddingLeft: "10px",
                marginLeft: "-7px",
                paddingRight: "10px",
              }}
              key={point}
              role={undefined}
              button
              onClick={handleToggle(value)}
              dense
              disabled={disabled}
            >
              <ListItemIcon
                sx={
                  indented
                    ? { minWidth: 0, marginLeft: "12px" }
                    : { minWidth: 0 }
                }
              >
                <ThemeProvider theme={theme}>
                  <Checkbox
                    color="primary"
                    edge="start"
                    checked={checked.indexOf(point) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": labelId }}
                  />
                </ThemeProvider>
              </ListItemIcon>
              <ListItemText
                sx={{
                  marginLeft: "0px",
                  userSelect: "none",
                  fontSize: "17px",
                  overflowWrap: "break-word",
                }}
                id={labelId}
                disableTypography={true}
                primary={`${point}`}
              />
            </ListItem>
            {(value.feedback || value.media) && (
              <HoverIcon comment={value.feedback} media={value.media} />
            )}
          </ListContainer>
        );
      })}
    </CheckboxContainer>
  );
}
